import React from "react";
import PropTypes from "prop-types";

import TopicUpdatesLink from "./TopicUpdatesLink";
import CinahlRedirectionLink from "./CinahlRegirectionLink";
import AboutCMElink from "./AboutCMElink";
import { Flex } from "@ebscois/react-component-library";
import { StyledPubTypeWrapper, StyledWrapper } from "./_.styled";

const PubTypeContent = ({ chemoRegimenPubTypeMetadata, prettyPubtype }) => {
  if (!chemoRegimenPubTypeMetadata) {
    return prettyPubtype;
  }

  const { templateId, updatedAtLabel } = chemoRegimenPubTypeMetadata;
  return (
    <>
      {prettyPubtype.toUpperCase()} <strong>{templateId}</strong>{" "}
      {updatedAtLabel}
    </>
  );
};

const UPPERCASE_PROP = { textTransform: "uppercase" };
const PubTypeLine = ({
  pubtypeTestId,
  prettyPubtype,
  createdAt,
  updatedAt,
  onTopicUpdatesLinkClick,
  chemoRegimenPubTypeMetadata,
  cinahlRedirectionLink,
  isCMELinkVisible,
  productName,
}) => (
  <Flex container>
    <StyledWrapper container>
      <StyledPubTypeWrapper
        element="span"
        color="gray800"
        fontFamily="base"
        data-testid={pubtypeTestId}
        {...(!chemoRegimenPubTypeMetadata && UPPERCASE_PROP)}
      >
        <PubTypeContent
          prettyPubtype={prettyPubtype}
          chemoRegimenPubTypeMetadata={chemoRegimenPubTypeMetadata}
        />
      </StyledPubTypeWrapper>

      <TopicUpdatesLink
        createdAtLabel={createdAt}
        updatedAtLabel={updatedAt}
        onClick={onTopicUpdatesLinkClick}
      />

      {cinahlRedirectionLink && (
        <CinahlRedirectionLink redirectionLink={cinahlRedirectionLink} />
      )}
    </StyledWrapper>
    {isCMELinkVisible && <AboutCMElink productName={productName} />}
  </Flex>
);

PubTypeLine.propTypes = {
  prettyPubtype: PropTypes.string.isRequired,
  pubtypeTestId: PropTypes.string,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
  onTopicUpdatesLinkClick: PropTypes.func.isRequired,
  chemoRegimenPubTypeMetadata: PropTypes.shape({
    templateId: PropTypes.string.isRequired,
    updatedAtLabel: PropTypes.string.isRequired,
  }),
  cinahlRedirectionLink: PropTypes.object,
  isCMELinkVisible: PropTypes.bool,
  productName: PropTypes.string,
};

PubTypeLine.displayName = "PubTypeLine";
export default PubTypeLine;
